import { customToast } from "../../../../shared";
import { success, withSpinner } from "../../../../redux/actions/utilities";
import {
  successMessages,
  toastTypes,
} from "../../constants";
import { mergeDuplicateStoresConstants } from "../../constants/mergeDuplicateStores.constants";
import { mergeDuplicateStoresServices } from "../../services/mergeDuplicateStores.service";

const { GET_MERGE_DUBLICATE_STORE_LOGS, MERGE_DUBLICATE_STORES } =
  mergeDuplicateStoresConstants;

const { DUBLICATE_STORE_MERGING_START_MESSAGE } = successMessages;

//Fetching survey queues paginated data
const getMergeDuplicateStoresLogs = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_MERGE_DUBLICATE_STORE_LOGS, () =>
      mergeDuplicateStoresServices
        .getMergeDuplicateStoresLogs(body)
        .then(
          (response) => {
            dispatch(success(response, GET_MERGE_DUBLICATE_STORE_LOGS));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

const mergeDublicateStores = (oldStoreId, newStoreId, callback, brandId) => {
  return (dispatch) => {
    withSpinner(dispatch, MERGE_DUBLICATE_STORES, () =>
      mergeDuplicateStoresServices
        .mergeDublicateStores(oldStoreId, newStoreId)
        .then(
          (response) => {
            customToast(
              DUBLICATE_STORE_MERGING_START_MESSAGE,
              toastTypes.SUCCESS,
              10000
            );
            dispatch(success(response, MERGE_DUBLICATE_STORES));
            callback(brandId);
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

export const mergeDuplicateStoresActions = {
  getMergeDuplicateStoresLogs,
  mergeDublicateStores,
};
